import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { api } from 'services';
import { Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import MasterPage from 'components/MasterPage';
import ListingCompanies from 'components/ListingCompanies';
import { DashboardOutlined } from '@material-ui/icons';

const Statement = () => {
  const defaultFilters = { search: '', per_page: 10, page: 1 };
  const [data, setData] = useState({ data: [] });
  const [filters, setFilters] = useState(defaultFilters);

  useEffect(() => {
    api
      .get('companies', { params: { ...filters } })
      .then(({ data }) => setData(data));
  }, [filters]);
  const { t } = useTranslation();

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:statement')}</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row className="mt-2">
              <Col>
                <ListingCompanies
                  fields={[{ name: 'logo', key: 'logo.uri', type: 'url' }]}
                  filters={[]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  data={data}
                  handleFilterChange={handleFilterChange}
                  actions={[
                    (company, k) => (
                      <Card.Text className="text-center align-middle">
                        <a
                          style={{ fontSize: '20px' }}
                          key={k}
                          href={`/statement/${company.id}`}
                        >
                          {company.alias}
                        </a>
                      </Card.Text>
                    )
                  ]}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

const mapStateToProps = state => ({});

const reduxConnect = connect(mapStateToProps)(Statement);

export default MasterPage(reduxConnect);
